import style from './Typography.css';

export default function Title({ className = '', text = '', ...props }) {
  return (
    <h1 className={`${className} ${style.title}`} {...props}>
      {text}
    </h1>
  );
}
